import { Box } from "@mui/material";
import React from "react";
import { lastUpdateFormatter } from "@/src/utils/dateFormatter";
import { FONT_UI } from "@/src/components/common/broadsheet/tokens";

interface LastUpdateProps {
  updatedAt: string;
}

const LastUpdate: React.FC<LastUpdateProps> = ({ updatedAt }) => {
  return (
    <Box
      sx={{
        fontFamily: FONT_UI,
        fontSize: "0.71875rem",
        lineHeight: 1.6,
        color: "custom.subtitleText",
        whiteSpace: "nowrap",
      }}
    >
      Last updated{" "}
      <Box component="span" sx={{ color: "custom.ink", fontWeight: 600 }}>
        {lastUpdateFormatter(updatedAt)}
      </Box>
    </Box>
  );
};

export default LastUpdate;
